@let savingDrawer = savingDrawer$ | async;
@let drawerVisible = drawerVisible$ | async;
@let trainingsToEdit = trainingsToEdit$ | async;
<nz-drawer
  [nzVisible]="drawerVisible === true && trainingsToEdit?.length"
  [nzMask]="true"
  [nzMaskClosable]="true"
  [nzPlacement]="'right'"
  [nzClosable]="false"
  [nzTitle]="'general.edit' | translate"
  [nzSize]="'large'"
  [nzFooter]="drawerFooter"
  (nzOnClose)="closeBulkEditDrawer()"
>
  <ng-container *nzDrawerContent>
    <form nz-form nzLayout="vertical">
      <wilson-training-qualifications-bulk-edit-info-section></wilson-training-qualifications-bulk-edit-info-section>

      <hr />

      <wilson-training-qualifications-bulk-edit-general-section
        [nameFormControl]="nameFormControl"
        [labelFormControl]="labelFormControl"
        [statusFormControl]="statusFormControl"
        [hasMixedValues]="selectionHasMixedValues"
        [containsTrainingsFromDigitalProvider]="
          selectionContainsTrainingsFromDigitalProvider
        "
      ></wilson-training-qualifications-bulk-edit-general-section>

      <hr />

      <wilson-training-qualifications-bulk-edit-attachments-section
        [(fileList)]="attachmentsList"
        [disabledNzUpload]="savingDrawer"
        [disabledFileList]="savingDrawer"
        [multipleTrainingsSelected]="
          trainingsToEdit && trainingsToEdit.length > 1
        "
      ></wilson-training-qualifications-bulk-edit-attachments-section>

      <hr />

      <wilson-training-qualifications-bulk-edit-notes-section
        [notesFormControl]="notesFormControl"
        [hasMixedValues]="selectionHasMixedValues"
        [containsTrainingsFromDigitalProvider]="
          selectionContainsTrainingsFromDigitalProvider
        "
      ></wilson-training-qualifications-bulk-edit-notes-section>
    </form>
  </ng-container>
</nz-drawer>

<ng-template #drawerFooter>
  <wilson-training-qualifications-bulk-edit-footer-section
    (cancelDrawer)="cancelDrawer()"
    (saveDrawer)="saveDrawer()"
    [saveButtonDisabled]="
      !(
        (nameFormControl.dirty && nameFormControl.value) ||
        (statusFormControl.dirty && statusFormControl.value) ||
        (labelFormControl.dirty && labelFormControl.value) ||
        notesFormControl.dirty ||
        (haveAttachmentsChanged() &&
          nameFormControl.valid &&
          statusFormControl.valid)
      )
    "
    [loading]="savingDrawer"
  ></wilson-training-qualifications-bulk-edit-footer-section>
</ng-template>
